const CardProjectFicheHrs2 = ({ className = "", title = "", icon = "", hrs = 0 }) => {
	return (
		<div className={`rounded-md px-4 py-2 xl:h-[64px] flex flex-col xl:flex-row xl:justify-between ${className}`}>
			<div className="flex gap-2 items-center">
				<div className={`w-[24px] h-[24px]`}>
					<img className="h-full w-full object-contain" src={icon} alt="icon" />
				</div>
				<div className="w-full">
					<p className="font-bold text-[10px]">{title}</p>
				</div>
			</div>
			<div className="flex justify-end items-center">
				<p className="text-[20px] font-semibold">{hrs}</p>
			</div>
		</div>
	);
};

export default CardProjectFicheHrs2;
